export default __webpack_public_path__ + "static/media/1.d31a84e0.jpg";